/**
 * Build a DOM id for a checkpoint/stop editor card so other components can scroll to it.
 * @param {{ id?: string|number }} [stop]
 * @param {number} [fallbackIndex=0]
 * @returns {string}
 */
const checkpointDomId = (stop, fallbackIndex = 0) => {
  const rawId =
    stop?.id != null && `${stop.id}`.length
      ? stop.id
      : `idx-${fallbackIndex}`;
  return `checkpoint-editor-${rawId}`;
};

export default checkpointDomId;
